/* KinderSpeech 2.0 - Listicle (összehasonlítás-angle) asset. Vanilla, defer. Scope: .ksl
   Funkciók: napvégi countdown, szín x csomag variant-mátrix, sticky ATC (IntersectionObserver),
   görgető CTA-k, placeholder-variant védelem. */
(function(){
  var root = document.getElementById('ksl');
  if(!root) return;
  var U = {h:'óra', m:'perc', s:'mp'};

  /* ---- countdown: napvégéig (ma éjfélig) ---- */
  function endOfDay(){ var n = new Date(); n.setHours(23,59,59,999); return n.getTime(); }
  function pad(x){ return (x<10?'0':'')+x; }
  root.querySelectorAll('[data-cd]').forEach(function(cd){
    function tick(){
      var t = endOfDay() - Date.now(); if(t < 0) t = 0;
      var h = Math.floor(t/36e5), m = Math.floor(t%36e5/6e4), s = Math.floor(t%6e4/1e3);
      cd.textContent = pad(h)+' '+U.h+'  '+pad(m)+' '+U.m+'  '+pad(s)+' '+U.s;
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---- szín x csomag -> variant ID mátrix ----
     KÉK variánsok élesek. Rózsaszín / Dínós: töltsd ki a valós variant ID-kkal! */
  var MATRIX = {
    kek:       { '224':'52203454791946', '362':'52203491557642', '562':'52203491590410' },
    rozsaszin: { '224':'ROZSASZIN_224_VARIANT_ID', '362':'ROZSASZIN_362_VARIANT_ID', '562':'ROZSASZIN_562_VARIANT_ID' },
    dinos:     { '224':'DINOS_224_VARIANT_ID', '362':'DINOS_362_VARIANT_ID', '562':'DINOS_562_VARIANT_ID' }
  };
  var sel = { color:'kek', pkg:'562' };
  var vidInput = root.querySelector('#ksl-vid');
  var stickyPrice = root.querySelector('[data-sticky] .ksl-sp');
  var warn = root.querySelector('#ksl-variant-warn');

  function pkgPrice(pkg){ var el = root.querySelector('[data-pkg="'+pkg+'"] .p'); return el ? el.textContent : ''; }

  function sync(){
    var v = (MATRIX[sel.color] || {})[sel.pkg] || '';
    var live = /^[0-9]+$/.test(v);
    if(vidInput) vidInput.value = live ? v : '';
    if(stickyPrice) stickyPrice.textContent = pkgPrice(sel.pkg);
    root.querySelectorAll('[data-atc]').forEach(function(b){ b.disabled = !live; b.style.opacity = live ? '' : '0.45'; });
    if(warn) warn.style.display = live ? 'none' : 'block';
  }

  root.querySelectorAll('[data-color]').forEach(function(el){
    el.addEventListener('click', function(){
      sel.color = el.getAttribute('data-color');
      root.querySelectorAll('[data-color]').forEach(function(x){ x.classList.toggle('is-sel', x===el); });
      sync();
    });
  });
  root.querySelectorAll('[data-pkg]').forEach(function(el){
    el.addEventListener('click', function(){
      sel.pkg = el.getAttribute('data-pkg');
      root.querySelectorAll('[data-pkg]').forEach(function(x){ x.classList.remove('is-sel'); var r=x.querySelector('input'); if(r) r.checked=false; });
      el.classList.add('is-sel'); var r=el.querySelector('input'); if(r) r.checked=true;
      sync();
    });
  });

  /* ---- görgető CTA-k -> az offer blokkra ---- */
  root.querySelectorAll('[data-scroll]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.preventDefault();
      var t = root.querySelector('#ksl-offer');
      if(t) t.scrollIntoView({behavior:'smooth', block:'start'});
    });
  });

  /* ---- sticky ATC sáv: a hero után jelenik meg ---- */
  var bar = root.querySelector('[data-sticky]');
  var anchor = root.querySelector('#ksl-anchor');
  if(bar && anchor && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    });
    io.observe(anchor);
  }

  sync();
})();
